/**
 * AgencyFocusPanel — what an agency operator needs to ACTION today.
 */
import React from 'react';
import { FocusCard, FocusHero } from './FocusCard';

export function AgencyFocusPanel({ focus }) {
  const blocks = focus?.blocks || [];
  const byKey = Object.fromEntries(blocks.map((b) => [b.key, b]));

  return (
    <div className="space-y-6" data-testid="agency-focus-panel">
      <FocusHero
        title="Capacity & coverage at a glance."
        subtitle="Open offers and credential lapses come first — everything else lives under the full dashboard below."
        primaryAction={focus?.primary_action}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FocusCard
          block={byKey.offers_waiting_clinicians}
          testIdPrefix="agency-focus"
          emptyHint="Every offer is matched."
        />
        <FocusCard
          block={byKey.credentialing_lapses_30d}
          testIdPrefix="agency-focus"
          emptyHint="No credentials expiring in 30 days."
        />
      </div>
    </div>
  );
}
